import { isEmpty } from 'lodash';

export class SubjectNaturalKey {
    constructor(
        public readonly zcSubjectId: string,
        public readonly siteId: string,
    ) {}

    public static fromString(subjectNaturalKey: string | null): SubjectNaturalKey | null {
        if (isEmpty(subjectNaturalKey)) {
            return null;
        }

        const result = subjectNaturalKey.split('|');

        return new SubjectNaturalKey(result[0], result[1]);
    }
}
